import React from 'react';
import Icon from '../../../components/AppIcon';

const ContentTypeFilter = ({ activeFilter, onFilterChange, counts }) => {
  const filters = [
    { id: 'all', label: 'All Content', icon: 'FileText', count: counts?.all },
    { id: 'published', label: 'Published', icon: 'CheckCircle', count: counts?.published },
    { id: 'scheduled', label: 'Scheduled', icon: 'Clock', count: counts?.scheduled },
    { id: 'draft', label: 'Drafts', icon: 'Edit', count: counts?.draft },
    { id: 'failed', label: 'Failed', icon: 'XCircle', count: counts?.failed }
  ];

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      {filters?.map((filter) => (
        <button
          key={filter?.id}
          onClick={() => onFilterChange(filter?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
            activeFilter === filter?.id
              ? 'bg-primary text-primary-foreground shadow-sm'
              : 'bg-muted text-foreground hover:bg-muted/80'
          }`}
        >
          <Icon name={filter?.icon} size={16} />
          <span>{filter?.label}</span>
          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
            activeFilter === filter?.id
              ? 'bg-primary-foreground/20 text-primary-foreground'
              : 'bg-background text-foreground'
          }`}>
            {filter?.count}
          </span>
        </button>
      ))}
    </div>
  );
};

export default ContentTypeFilter;